<template>
    <CardDropdownSm :item="fileData">
        <template #icon>
            <component v-if="fileIcon" :is="fileIcon" class="flex-shrink-0 w-4 h-4 ct-fg-2" />
        </template>
        <template #extra>
            <InvisibleIcon
                v-if="file.hide"
                @click.stop="toggleHide"
                class="flex-shrink-0 w-4 h-4 ct-fg-4 hover:ct-fg-2"
            />
        </template>
    </CardDropdownSm>
</template>

<script>
import {
    NewFolderIcon,
    VideoIcon,
    PencilSquareIcon,
    CopyDocumentIcon,
    TrashBinIcon,
    VisibleIcon,
    InvisibleIcon,
    AudioIcon,
    PdfIcon,
    DownloadFileIcon,
    EmbedIcon,
    ImageIcon,
    TextFileIcon,
} from "@easy/ui/icons";
import { CardDropdownSm } from "@easy/ui/cards";
import { markRaw } from "vue";
import { PLAYER_FILE_TYPES } from "@/apps/player/services/players.service";
import { mapMutations } from "vuex";

export default {
    components: {
        NewFolderIcon,
        CardDropdownSm,
        InvisibleIcon,
    },
    props: {
        file: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showLink: false,
        };
    },
    emits: ["edit", "delete", "duplicate"],
    computed: {
        fileData() {
            return {
                title: this.file.name,
                actions: [
                    {
                        label: this.$t("shared.edit"),
                        icon: PencilSquareIcon,
                        handler: () => this.$emit("edit"),
                    },
                    {
                        label: this.$t("shared.duplicate"),
                        icon: CopyDocumentIcon,
                        handler: () => this.$emit("duplicate"),
                    },
                    {
                        label: this.file.hide ? this.$t("shared.show") : this.$t("shared.hide"),
                        icon: this.file.hide ? VisibleIcon : InvisibleIcon,
                        handler: this.toggleHide,
                    },
                    { isDivider: true },
                    {
                        label: this.$t("shared.delete"),
                        icon: TrashBinIcon,
                        isDanger: true,
                        handler: () => this.$emit("delete"),
                    },
                ],
            };
        },
        fileIcon() {
            let icon;
            switch (this.file.type) {
                case PLAYER_FILE_TYPES.header:
                    icon = markRaw(NewFolderIcon);
                    break;
                case PLAYER_FILE_TYPES.audio:
                    icon = markRaw(AudioIcon);
                    break;
                case PLAYER_FILE_TYPES.video:
                    icon = markRaw(VideoIcon);
                    break;
                case PLAYER_FILE_TYPES.pdf:
                    icon = markRaw(PdfIcon);
                    break;
                case PLAYER_FILE_TYPES.file:
                    icon = markRaw(DownloadFileIcon);
                    break;
                case PLAYER_FILE_TYPES.embed:
                    icon = markRaw(EmbedIcon);
                    break;
                case PLAYER_FILE_TYPES.image:
                    icon = markRaw(ImageIcon);
                    break;
                case PLAYER_FILE_TYPES.text:
                    icon = markRaw(TextFileIcon);
                    break;
                case PLAYER_FILE_TYPES.google:
                    icon = markRaw(TextFileIcon);
                    break;
                default:
                    icon = null;
            }
            return icon;
        },
    },
    methods: {
        ...mapMutations(["showAlert"]),
        toggleHide() {
            if (!this.file._created) {
                this.file._changed = true;
            }
            this.file.hide = !this.file.hide;
            this.showAlert({
                type: "success",
                title: this.file.hide
                    ? this.$t("player.files.file_hidden")
                    : this.$t("player.files.file_visible"),
            });
        },
    },
};
</script>
